<template>
    <div class="mb-3">
        <div class="section-header" :class="{ open: !collapsed }" @click="collapsed = !collapsed" role="button"
            tabindex="0" @keydown.enter.space.prevent="collapsed = !collapsed" :aria-expanded="!collapsed">
            <div class="section-header-left">
                <span class="section-title">Corridorings</span>
            </div>
            <span class="section-chevron" :class="{ open: !collapsed }" aria-hidden="true">▾</span>
        </div>

        <div v-if="!collapsed">
            <div class="d-flex align-items-center gap-2 mb-2">
                <input v-model="search" type="text" class="form-control form-control-sm" placeholder="Rechercher…"
                    @keyup.enter="emitSearch" />
            </div>

            <div class="list-group small">
                <button type="button" class="list-group-item list-group-item-action py-1"
                    :class="{ active: !selectedId }" @click="$emit('select', null)">
                    Aucun corridoring
                </button>

                <button v-for="c in corridorings" :key="c.id" type="button"
                    class="list-group-item list-group-item-action py-1" :class="{ active: c.id === selectedId }"
                    @click="$emit('select', c.id)">
                    <span class="text-truncate d-block">{{ c.name }}</span>
                </button>

                <div v-if="!corridorings?.length && !loading" class="text-muted px-2 py-1">
                    Aucun corridoring
                </div>
                <div v-if="loading" class="text-muted px-2 py-1">
                    Chargement…
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PanelSectionCorridoring",
    props: {
        corridorings: { type: Array, default: () => [] },
        selectedId: { type: Number, default: null },
        loading: { type: Boolean, default: false },
    },
    emits: ["select", "refresh"],
    data() {
        return {
            collapsed: true,
            search: "",
            searchTimeout: null,
        };
    },
    watch: {
        search() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.emitSearch();
            }, 400);
        },
    },
    methods: {
        emitSearch() {
            this.$emit("refresh", (this.search || "").trim());
        },
    },
};
</script>

<style scoped>
.list-group-item.active {
    background: #0d6efd;
    border-color: #0d6efd;
    color: #fff;
}

.section-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .75rem;
    min-height: 42px;
    padding: .65rem .8rem;
    margin-bottom: .75rem;
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: .75rem;
    background: #f8f9fa;
    color: #495057;
    transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;
    user-select: none;
}

.section-header:hover,
.section-header:focus {
    background: #eef3f8;
    border-color: rgba(13, 110, 253, .25);
    box-shadow: 0 0 0 3px rgba(13, 110, 253, .08);
    outline: none;
}

.section-header.open {
    background: #eef4ff;
    border-color: rgba(13, 110, 253, .28);
}

.section-header-left {
    display: flex;
    align-items: center;
    min-width: 0;
}

.section-title {
    font-size: .9rem;
    font-weight: 600;
    color: #212529;
}

.section-chevron {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: rgba(0, 0, 0, .05);
    color: #495057;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1;
    transform: rotate(-90deg);
    transition: transform .18s ease, background-color .18s ease, color .18s ease;
}

.section-chevron.open {
    transform: rotate(0deg);
    background: rgba(13, 110, 253, .12);
    color: #0d6efd;
}
</style>